module.exports = __webpack_public_path__ + "vue_assets/img/img_setting_lostciv.2cdd51d1.png";